import { isPromise } from './promise';
export let sessionStorage;
const parseCompany = (val) => {
    if (!val)
        return;
    const company = JSON.parse(val);
    if (company && typeof company === 'object') {
        const casted = company;
        if (typeof casted.id !== 'string')
            return; // id is required
        return {
            id: casted.id,
        };
    }
};
const companyKey = 'currentCompany';
/**
 * Gets the current company that the user is viewing from session storage.
 * @returns
 */
export function getCompanyFromSessionStorage() {
    const result = sessionStorage.getItem(companyKey);
    return isPromise(result) ? result.then(parseCompany) : parseCompany(result);
}
export function removeCompanyFromSessionStorage() {
    return sessionStorage.removeItem(companyKey);
}
export function setCompanyForSessionStorage(companyId) {
    void sessionStorage.setItem(companyKey, JSON.stringify({ id: companyId }));
}
export function initializeSessionStorage(storage) {
    sessionStorage = storage;
}
//# sourceMappingURL=cross-platform-session-storage.js.map